import React from 'react';
import { useDesign } from '../contexts/DesignContext';
import StaticPageLayout from '../components/Layout/StaticPageLayout';

const PrivacyPolicy = () => {
  const { designConfig } = useDesign();
  const siteName = designConfig.site_name || 'Viverra';
  const contactEmail = designConfig.contact_email || '[TODO: add support email in Admin Settings]';

  return (
    <StaticPageLayout title="Privacy Policy" draftNotice>
      <p>
        This Privacy Policy explains how {siteName} collects, uses, and protects information when you use our
        website and place orders with us.
      </p>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Information We Collect</h2>
        <p>
          When you create an account, browse products, or place an order, we may collect your name, email
          address, phone number, shipping/billing address, and order history.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Payment Information</h2>
        <p>
          We do not store your card or full payment details ourselves - payments are processed securely by our
          payment gateway partners.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">How We Use Your Information</h2>
        <p>
          We use your information to process and deliver orders, manage your account, respond to support
          requests, and send order-related communications.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Sharing of Information</h2>
        <p>
          We share information only with the parties needed to fulfil your order, such as payment processors
          and delivery/logistics partners. We do not sell your personal information.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Cookies</h2>
        <p>
          We use cookies to keep you signed in, remember your cart, and understand how our site is used.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Your Rights</h2>
        <p>
          You can request access to, correction of, or deletion of your personal information by contacting us
          at {contactEmail}.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Grievance Officer</h2>
        <p>[TODO: add grievance officer name, email, and phone as required under Indian IT Rules].</p>
      </div>

      <p className="text-sm text-gray-500">Last updated: [TODO: add date].</p>
    </StaticPageLayout>
  );
};

export default PrivacyPolicy;
